import { styled } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import PlayIcon from '@material-ui/icons/PlayArrowRounded'

export const CardXlRoot = styled(Box)(() => ({
  display: 'flex',
  backgroundColor: 'white',
}))

export const Cta = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  left: 0,
}))

const iconSize = 48
const outerRing = 10
export const VideoIcon = styled(PlayIcon)(() => ({
  position: 'absolute',
  color: '#fff',
  top: `calc(50% - ${(iconSize + (outerRing * 2)) / 2}px)`,
  left: `calc(50% - ${(iconSize + (outerRing * 2)) / 2}px)`,
  height: `${iconSize + (outerRing * 2)}px`,
  width: `${iconSize + (outerRing * 2)}px`,
  padding: outerRing,
  border: '2px solid',
  borderRadius: '50%',
}))
